export enum QUESTION_TYPE {
  MULTI = 1,
  OPEN = 2,
  RELATIONAL = 3,
  TRUE_AND_FALSE = 4,
  IMAGE_MULTI = 5,
}